import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UnmatchedLock } from '@app/shared/services/smartlocks/smartlocks.service';

@Component({
  standalone: false,
  selector: 'sbnb-unmatched-lock',
  templateUrl: './unmatched-lock.component.html',
  styleUrls: ['./unmatched-lock.component.scss'],
})
export class UnmatchedLockComponent {
  @Input()
  lock: UnmatchedLock;

  @Output() editLock = new EventEmitter<UnmatchedLock>();

  editLockEvent() {
    this.editLock.emit(this.lock);
  }
}
